export default __webpack_public_path__ + "static/media/vodacom.30b70e2d.jpg";